import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from 'src/app/comp/nav/nav.component';
import { RouterModule } from '@angular/router';
import { Footer2Component } from 'src/app/comp/footer2/footer2.component';
import { FooterComponent } from 'src/app/comp/footer/footer.component';



@NgModule({
  declarations: [NavComponent, Footer2Component, FooterComponent],
  imports: [
    CommonModule, RouterModule
  ],
  exports: [NavComponent, Footer2Component, FooterComponent]
})
export class SharedModule { }
